import React from 'react';
import './Support-page.scss';

function SupportPage() {
  return (
    <div className="support-page-wrapper">
      <div className="support-grid">

        {/* Email Support */}
        <section className="card">
          <div className="card-icon">
            {/* Email SVG */}
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18v12H3z" stroke="#5b2a82" strokeWidth="2"/>
              <path d="M3 6l9 7 9-7" stroke="#5b2a82" strokeWidth="2"/>
            </svg>
          </div>
          <h2 className="section-title">Email Support</h2>
          <a href="mailto:vickipfsupport@viatouchmedia.com" className="pill">
            vickipfsupport@viatouchmedia.com
          </a>
        </section>

        {/* Phone Support */}
        <section className="card">
          <div className="card-icon">
            {/* Phone SVG */}
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M6.6 10.8a15.05 15.05 0 006.6 6.6l2.2-2.2a1 1 0 011-.24c1.1.37 2.3.56 3.5.56a1 1 0 011 1V20a1 1 0 01-1 1C10.3 21 3 13.7 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.2.2 2.4.56 3.5a1 1 0 01-.25 1l-2.2 2.3z" stroke="#5b2a82" strokeWidth="2"/>
            </svg>
          </div>
          <h2 className="section-title">Phone Support</h2>
          <a href="tel:18669420804" className="pill">
            1-866-942-0804
          </a>
        </section>

        {/* Open a Ticket */}
        <section className="card">
          <div className="card-icon">
            {/* Ticket SVG */}
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M4 7h16v4a2 2 0 000 4v4H4v-4a2 2 0 000-4V7z" stroke="#5b2a82" strokeWidth="2"/>
              <path d="M12 7v10" stroke="#5b2a82" strokeWidth="2" strokeDasharray="2 2"/>
            </svg>
          </div>
          <h2 className="section-title">Open a Ticket</h2>
          <a
            href="https://dashboard.getvicki.com:5000/tickets/add-new-ticket-request"
            target="_blank"
            rel="noopener noreferrer"
            className="pill"
          >
            Open Ticket Portal
          </a>
        </section>

      </div>
    </div>
  );
}

export default SupportPage;